import React from "react";
import { ISocieteDetails } from "../../../models/interfaces/ISociete";
import RowDetail from "../components/detail/RowDetail";
//Styles:

interface IProps {
    MarqueResult: ISocieteDetails;
}



const MarqueBloc3: React.FC<IProps> = ({
  MarqueResult
}) => {
  return (
    <div className="card pae-detail-pub-card ">
            <div className="col-sm-12 card-body pae-card-grey" style={{maxHeight: "50px" , textAlign: 'left'}}>
            <div className="row">
                  <div className="col-12 pae-detail-label">
                      <b>Liens administratifs</b> 
                  </div>
              </div>
            </div>
              <div className="col-sm-12 card-body" style={{ padding: '15px' }}>
              <RowDetail titre="Marque de" donnee={MarqueResult?.LienAdministratif?.RaisonSocialeSocieteLiee} />
              </div>
            </div>
  );
};

export default MarqueBloc3;
